/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-10-29 17:09:58
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2020-10-29 19:09:28
 * @Content:
 */

import React, { FC, memo, useCallback } from "react";
import classnames from "classnames";
import { IGoalCarouselItemState } from "./interface";
import "./index.css";

const PREFIX = "GoalCarouselItem";

interface IProps {
  isSelected: boolean;
  onClick: (index: number) => void;
  state: IGoalCarouselItemState;
  index: number;
}

const GoalCarouselItem: FC<IProps> = memo(
  ({ isSelected, onClick, index, state }) => {
    const handleClick = useCallback(() => {
      onClick(index);
    }, [onClick, index]);

    // 按钮默认为 未开始 状态
    return (
      <div className={`${PREFIX}-wrapper`}>
        <div
          className={classnames(PREFIX, {
            ["is-selected"]: isSelected, // 选中
            ["is-inProgress"]: state == 1, // 进行中，可以去完成（设计状态与【未开始】一致，不需要特殊处理）
            ["is-finish"]: state == 2 || state == 3, // 已结束，未完成
          })}
          onClick={handleClick}
        >
          <div className={`${PREFIX}-text`}>{`目标${index + 1}`}</div>
          {state == 2 ? (
            <img
              className={`${PREFIX}-icon`}
              src="https://s1.codooncdn.com/operation-tools/internal-user/2020-10-29T17.38.53/34x34x1015xxanq3wuUprgSmCsjzT.png"
            />
          ) : null}
        </div>
      </div>
    );
  }
);

export default GoalCarouselItem;
